<div class="p-4 pt-8 md:pt-4">
  <span
    class="mb-2 block text-blue-500 cursor-pointer hover:underline"
    [ngClass]="{
      '!text-gray-400 !cursor-auto !hover:no-underline !no-underline':
        isDownloadingEntries
    }"
    (click)="downloadEntriesAsCsv()"
    >{{
      isDownloadingEntries ? "Please wait..." : "Download entries as CSV"
    }}</span
  >
  <div class="mb-6">
    <span
      >You can open CSV files in Google Sheets, Apple Numbers, Microsoft Excel
      or even Google Chrome.</span
    >
  </div>
  <span
    class="mb-2 block text-blue-500 cursor-pointer hover:underline"
    mat-flat-button
    (click)="clearCache()"
    [ngClass]="{ 'text-gray-500': isClearingCache }"
  >
    {{
      !isClearingCache
        ? "Clear cache and reload"
        : "Clearing cache and restarting..."
    }}
  </span>
  <div>
    <span
      >Get the latest version of Prefund by clearing the cache, deleting all the
      service workers and reloading the window. Your current version is
      {{ version }}-{{ commitHash }}.</span
    >
  </div>
</div>
